import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { GoogleMap, LoadScript, Polyline, Marker, InfoWindow } from "@react-google-maps/api";
import API from '../../services/api-service';
import { Main, ContenedorFechas } from '../Historico/ElementosStyles';
import { Button } from "react-bootstrap";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import Select from '../../components/Entradas/Select/index';
import SearchIcon from '@mui/icons-material/Search';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

const TrackRoutes = () => {
  const query = new URLSearchParams(useLocation().search);
  const deviceID = query.get("deviceID");
  const history = useHistory();
  const [apiLoaded, setApiLoaded] = useState(false);
  const [rutaVehiculo, setRutaVehiculo] = useState([]);
  const [visiblePoints, setVisiblePoints] = useState([]);
  const [date, setDate] = useState(new Date());
  const [dateRuta, setDateRuta] = useState(new Date());
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(100);
  const center = rutaVehiculo[0] || { lat: 0, lng: 0 };

  const getData = () => {
    API.getTrackerRoute(deviceID, date).then((response) => {
      console.log(response.data)
      const transformedArray = response.data.map(({ latitude, longitude, ...rest }) => ({
        ...rest,
        lat: latitude,
        lng: longitude
      }));
      setRutaVehiculo(transformedArray);
      setVisiblePoints([]);
      setCurrentIndex(0);
      setIsPlaying(false);
      setSelectedPoint(null);
    }).catch((error) => {
      console.log(error)
    })
  }

  useEffect(() => {
    let interval;

    if (isPlaying && currentIndex < rutaVehiculo.length) {
      interval = setInterval(() => {
        setVisiblePoints(prev => [...prev, rutaVehiculo[currentIndex]]);
        setCurrentIndex(prev => prev + 1);
        setDateRuta(new Date(rutaVehiculo[currentIndex].fechaCompleta));
      }, playbackSpeed);
    } else if (currentIndex >= rutaVehiculo.length) {
      setIsPlaying(false);
    }

    return () => clearInterval(interval);
  }, [isPlaying, currentIndex, rutaVehiculo]);

  const togglePlay = () => {
    if (rutaVehiculo.length === 0) return;

    if (isPlaying) {
      setIsPlaying(false);
    } else {
      if (currentIndex >= rutaVehiculo.length) {
        setVisiblePoints([]);
        setCurrentIndex(0);
      }
      setIsPlaying(true);
    }
  };

  return (
    <>
      <Main>
        <ContenedorFechas>
          <Button onClick={() => { history.goBack() }}>Atras</Button>
        </ContenedorFechas>
      </Main>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: '2rem' }}>
        <ContenedorFechas>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              renderInput={(props) => <TextField {...props} />}
              label="Fecha"
              value={date}
              onChange={setDate}
              inputFormat="dd/MM/yyyy"
            />
          </LocalizationProvider>
        </ContenedorFechas>
        <ContenedorFechas>
          <Button onClick={getData}><SearchIcon /></Button>
        </ContenedorFechas>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '1.5rem' }}>
        <Select
          message="Velocidad de Reproducción"
          data={[
            { label: "x0.25", value: 500 },
            { label: "x0.5", value: 225 },
            { label: "x1", value: 100 },
            { label: "x1.5", value: 50 },
            { label: "x2", value: 10 },
            { label: "x2.5", value: 5 }
          ]}
          value={playbackSpeed}
          setFunction={setPlaybackSpeed}
          id="outlined-disabled"
        />
        <Button
          onClick={togglePlay}
          disabled={rutaVehiculo.length === 0}
          variant={isPlaying ? "danger" : "success"}
        >
          {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
        </Button>
      </div>
      <Main>
        <p>{dateRuta.toLocaleString('es-ES', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZone: 'UTC'
        })}</p>
        <LoadScript googleMapsApiKey="AIzaSyBYNDUEf0g8OQPJfiEW7ybizYPiMN_7XOU" onLoad={() => setApiLoaded(true)}>
          <GoogleMap
            mapContainerStyle={{ height: "500px", width: "100%" }}
            zoom={15}
            center={visiblePoints.length > 0 ? visiblePoints[visiblePoints.length - 1] : center}
          >
            {visiblePoints.map((p, index) => {
              let circleColor = { backgroundColor: "#0000FF", borderColor: "#000066" };
              if (p.ACC) {
                circleColor = { backgroundColor: "#00FF00", borderColor: "#006600" };
                if (p.speed >= 100) {
                  circleColor = { backgroundColor: "#FF0000", borderColor: "#660000" };
                }
              }
              const circleSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <circle 
                  cx="12" 
                  cy="12" 
                  r="10" 
                  fill="${circleColor.backgroundColor}" 
                  stroke="${circleColor.borderColor}" 
                  stroke-width="3"
                />
              </svg>`;

              return (
                <React.Fragment key={index}>
                  <Marker
                    position={p}
                    onClick={() => setSelectedPoint(p)}
                    icon={{
                      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(circleSvg)}`,
                      scaledSize: new window.google.maps.Size(15, 15),
                    }}
                  />

                  {selectedPoint && selectedPoint._id === p._id && (
                    <InfoWindow
                      position={p}
                      onCloseClick={() => setSelectedPoint(null)}
                    >
                      <div style={{ padding: '5px' }}>
                        <p><b>ID:</b> {p.deviceId}</p>
                        <p><b>Fecha:</b> {new Date(p.fechaCompleta).toLocaleString('es-ES', {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          timeZone: 'UTC'
                        })}</p>
                        <p><b>Velocidad:</b> {p.speed || 'N/A'} km/h</p>
                        <p><b>Estado:</b> {p.ACC ? 'Encendido' : 'Apagado'}</p>
                        <p><b>GPS:</b> {p.GPS ? 'Conectado' : 'Desconectado'}</p>
                        <p><b>Coordenadas:</b> {p.lat.toFixed(6)}, {p.lng.toFixed(6)}</p>
                        <p><b>Batería:</b> {p.batteryVoltage}</p>
                        <p><b>Intensidad de la señal:</b> {p.networkSignalStrength}</p>
                        <p><b>Kilometraje:</b> {p.mileage}</p>
                        <p><b>Altitud:</b> {p.altitude}</p>
                      </div>
                    </InfoWindow>
                  )}
                </React.Fragment>
              );
            })}
          </GoogleMap>
        </LoadScript>
      </Main>
    </>
  );
};

export default TrackRoutes;